function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#5BA8AE",
  d: "M353.664,174.2c8.029-17.559-22.393-5.76-31.016-4.314c-7.236,1.213-9.852,4.637-10.988,11.504 c-1.766,10.663,0.289,14.839-9.672,22.812c-7.031,5.63-20.566,6.435-29.029,8.989c-9.439,2.853-11.15-1.307-19.035-4.708 c-9.551-4.115-15.094-15.808-19.828-25.525c-1.443-2.952-0.539-7.943-1.488-10.821c-1.07-3.249-5.082-6.04-6.441-9.994 c-1.682-4.89,0.693-5.145,0.355-9.398c-0.545-6.745-3.137-15.68-2.293-21.33c0.988-6.706,7.209-12.334,7.225-20.361 c-4.932,0.339-14.793-1.564-18.256-4.09c-6.516-4.747-7.404-12.17-11.645-18.751c-6.432-9.979-10.91-24.601-21.975-27.545 c-1.881-0.502-6.061-1.567-7.475-0.619c-3.426,2.281-4.068,8.392-7.477,9.867c-3.223,1.394-14.096-4.792-15.904-9.304 c-1.693-4.201-1.893-8.305-4.373-12.214c-2.047-3.233-6.959-5.696-9.518-8.943c-6.82-8.657-14.057-7.342-25.178-8.03 c-0.311,1.867-0.744,4.102-0.289,5.949c-11.92-0.558-24.639-0.149-35.721-4.215c-5.766-2.114-35.301-14.123-33.535-19.662 C31.457,13.049,22.723,13.099,14.043,13c3.236,3.546,3.225,10.821,3.225,10.821c0.865,5.158,5.305,9.556,7.02,14.7 c1.51,4.578,1.037,10.223,4.096,14.917c5.461,8.392,17.881,12.659,12.625,23.25c-2.186,0.196-6.959,0.974-10.648,0.746 c1.465,2.309,0.488,0.544,2.152,1.318c3.607,5.894,6.26,10.163,12.014,14.625c0.379,0.294,4.213-1.192,5.168-0.333 c1.547,1.41,2.635,5.059,2.635,5.059s5.168,3.718,5.295,3.904c4.457,6.934,0.82,16.481,2.725,20.86 c3.207,7.375,14.189,10.786,18.457,18.292c1.049,1.848,1.398,7.813,3.592,8.468c2.686,0.8,6.203-4.212,6.564-6.406 c0.516-3.139-6.492-12.101-8.873-13.872c0.205,0.155-2.721,3.741-4.291,1.445c-1.227-1.77-0.371-3.856-1.082-5.577 c-0.949-2.322-1.26-7.702-2.475-10.776c-3.035-7.687-3.002-14.099-7.598-20.982c-2.752-4.112-11.83-28.042-15.449-27.676 c-1.598-7.478-12.32-13.047-11.07-19.326c1.498-7.485-2.809-15.094-0.039-21.314c5.166,3.144,7.447,3.479,12.18,5.787 c7.098,3.447,4.928,9.199,7.432,16.977c3.752,11.626,6.016,19.079,14.457,28.782c0.926,1.068,2.02,3.391,2.447,3.921 c6.525-0.267,3.113,2.996,5.648,8.016c2.242,4.439,15.133,15.172,14.578,15.658c-0.061-0.028-0.871,13.659,3.43,9.864 c0.826,2.852,2.586,2.705,4.789,5.455c0.699,0.874,3.191,1.812,3.885,2.766c0.961,1.308-0.648,2.358,0.211,3.671 c4.729,7.243,14.916,13.023,17.303,21.73c6.359,5.024,7.721,13.308,10.449,21.188c1.711,4.947,4.379,6.543-1.281,11.398 c5.521,1.021-0.883,4.054-0.783,7.226c0.141,4.334,5.168,11.026,7.516,13.053c1.059,0.915,4.65,1.689,6.07,2.603 c4.234,2.719,9.045,9.337,14.002,12.22c4.961,2.899,11.381,2.226,15.533,4.137c2.662,1.232,4.838,5.072,5.404,5.536 c7.191,4.153,15.66,8.734,23.629,11.435c7.725,2.622,12.92,6.646,20.689,9.048c12.686,3.924,19.873,5.051,29.822-1.32 c2.164-1.385,2.203-1.465,4.496-2.272c0.332-2.483,1.115-3.716,2.518-1.035c0.979-0.53,0.973-1.263,2.359-1.157 c0.078,0.191,0.172,0.372,0.283,0.541c-0.533,0.366-1.57,1.326-1.77,1.526c14.201,0.475,22.941,13.282,31.875,21.107 c1.992-8.63-1.287-10.729,4.922-19.593c3.541-5.063,18.785,2.373,15.578-7.464c-0.943-2.854-6.521-12.886-8.102-17.922 c7.475-0.568,17.592-1.648,22.098-3.263c1.947-0.696,1.754-0.649,3.68,0.696c1.969-3.513,6.076-13.053,6.076-13.053l2.791-0.282 C342.299,202.12,349.969,178.54,353.664,174.2z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "M323.338,181.914l-1.035-1.792c7.143-5.248,9.342-15.138,4.809-22.992 c-4.865-8.427-15.641-11.313-24.066-6.446c-8.426,4.863-11.313,15.638-6.447,24.064c4.533,7.855,14.199,10.893,22.314,7.331 l1.035,1.792l-0.85,0.49l9.404,16.287l5.086-2.938l-9.402-16.287L323.338,181.914z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 311.855,
  cy: 165.94,
  r: 13.703
}));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "M193.908,202.603l-1.035-1.792c7.143-5.248,9.342-15.138,4.809-22.992 c-4.865-8.427-15.639-11.313-24.066-6.446c-8.426,4.863-11.313,15.638-6.447,24.064c4.533,7.855,14.199,10.893,22.316,7.331 l1.033,1.792l-0.85,0.49l9.404,16.287l5.088-2.938l-9.404-16.287L193.908,202.603z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 182.426,
  cy: 186.628,
  r: 13.703
}));

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "M213.014,129.583l-1.035-1.792c7.143-5.248,9.342-15.138,4.809-22.992 c-4.865-8.427-15.639-11.313-24.066-6.446c-8.426,4.863-11.313,15.638-6.447,24.064c4.533,7.855,14.199,10.893,22.316,7.331 l1.033,1.792l-0.85,0.491l9.404,16.287l5.088-2.938l-9.404-16.288L213.014,129.583z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 201.531,
  cy: 113.609,
  r: 13.703
}));

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "M29.104,33.596l-1.035-1.792c7.143-5.248,9.342-15.138,4.809-22.992C28.012,0.385,17.236-2.502,8.811,2.365 C0.385,7.229-2.502,18.003,2.363,26.43c4.533,7.855,14.199,10.893,22.314,7.331l1.035,1.792l-0.85,0.49l9.404,16.287l5.086-2.938 l-9.402-16.287L29.104,33.596z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 17.621,
  cy: 17.622,
  r: 13.703
}));

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "M119.211,103.418l-1.035-1.792c7.143-5.248,9.342-15.138,4.809-22.992 c-4.865-8.427-15.639-11.313-24.066-6.446c-8.426,4.863-11.313,15.638-6.447,24.064c4.533,7.855,14.199,10.893,22.316,7.331 l1.033,1.792l-0.85,0.49l9.404,16.287l5.088-2.938l-9.404-16.287L119.211,103.418z"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#FFFFFF",
  cx: 107.729,
  cy: 87.444,
  r: 13.703
}));

var SvgQueEsObs04 = function SvgQueEsObs04(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "355px",
    height: "263px",
    viewBox: "0 0 355 263",
    enableBackground: "new 0 0 355 263",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueEsObs04, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queEsObs_04.e8983737.svg";
export { ForwardRef as ReactComponent };